import {modalController} from "@ionic/vue";

export async function showModal(component, payload) {
    const modal = await modalController.create({
        component: component,
        componentProps: payload
    });
    await modal.present();
}